import { useState } from "react";
import { useFormik } from "formik";
import { forgotPassSchema } from "../../schemas/Login/forgotPassSchema";
import { reqResetEmail } from "../../api/userAPI";
import Alert from "react-bootstrap/Alert";

export default function ForgotPassword() {
  const [esperando, setEsperando] = useState(false);
  const [respuesta, setRespuesta] = useState("");
  const [alertType, setAlertType] = useState(null);
  const onSubmit = async (values, actions) => {
    setEsperando(true);
    try {
      const response = await reqResetEmail(values.email);
      if (response.data) {
        setAlertType("alert alert-success");
        setRespuesta(response.data.msj);
        setEsperando(false);
      }
    } catch (error) {
      setAlertType("alert alert-danger");
      const msg =
        error.response?.data?.msj ||
        error.response?.data?.msg ||
        "Error desconocido";
      setRespuesta(msg);
      setEsperando(false);
    }
    actions.resetForm();
  };
  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgotPassSchema,
    onSubmit,
  });
  return (
    <div className="custom-container pt-4">
      {esperando ? null : (
        <Alert variant={alertType} style={{ textAlign: "center" }}>
          <b>{respuesta}</b>
        </Alert>
      )}

      <div style={{ textAlign: "center" }}>
        <p>
          <b>
            Para recuperar tu contraseña ingresá tu correo electronico. <br />
            Nuestro BOT te enviará un mail con un link que te permitirá cambiar
            tu contraseña.
          </b>
        </p>
      </div>
      <br />
      <form onSubmit={handleSubmit} className="login-container m-auto">
        <label>Mail</label>
        <input
          type="email"
          placeholder="Mail"
          name="email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          className={errors.email && touched.email ? "input-error" : ""}
        />
        {errors.email && touched.email && (
          <p className="error">{errors.email}</p>
        )}
        <button
          disabled={isSubmitting || esperando}
          type="submit"
          className="customBtn"
        >
          Ingresar
        </button>
      </form>
    </div>
  );
}
